import { once } from 'lodash-es';
import { getNewRelicAgent } from 'newRelicAgent';

import { enableScriptForServiceWithConsent } from 'utils/enable-script-for-service-with-consent';
import { loadScript } from 'utils/loadScript';
import { usercentricsEnabled } from 'utils/usercentrics';
import { usercentricsServiceNames } from 'utils/usercentrics-content-change-event-listener';
import { usercentricsServiceStatus } from 'utils/usercentrics-service-status';

const loadFacebookSDK = () => {
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: '2621716591423959',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v18.0',
    });
  };

  const fbConfig = {
    id: 'facebook-sdk-v18',
    src: 'https://connect.facebook.net/en_US/sdk.js',
    defer: true,
    crossorigin: 'anonymous',
  };

  if (usercentricsEnabled()) {
    fbConfig.type = 'text/plain';
    fbConfig.dataset = {
      usercentrics: usercentricsServiceNames.facebook,
    };

    loadScript(fbConfig);

    enableScriptForServiceWithConsent();

    return usercentricsServiceStatus(usercentricsServiceNames.facebook) ? Promise.resolve() : Promise.reject();
  } else {
    return loadScript(fbConfig).catch(() => {
      getNewRelicAgent().noticeError(new Error('Share to Facebook: SDK cannot be loaded.'));
    });
  }
};

export const loadFacebookSDKOnce = once(loadFacebookSDK);
